import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {TextField, InputLabel, createStyles, Theme as AugmentedTheme} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';

interface INumber {
    field: CustomInputMappingField,
    value: string,
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
      //@ts-ignore
      inputLabel: theme.inputLabel,
      //@ts-ignore
      requiredLabel: theme.requiredLabel,
      //@ts-ignore
      requiredField: theme.requiredField,
}))


export default function NumberField({ field, value, onChangeHandler,isRtl }: INumber) {
    const classes = useStyles();
    const isEmpty = !value || value.trim() === ''
    const showRequired = field.required && isEmpty

    return(
        <>
          <InputLabel 
           style={{ 
            direction: isRtl ? 'rtl' : 'ltr',
            textAlign: isRtl ? 'right' : 'left' 
        }} 
        htmlFor={field.sourceField} className={showRequired ? classes.requiredLabel : classes.inputLabel}>{field.fieldName}</InputLabel>
          <TextField
          style={{ 
            direction: isRtl ? 'rtl' : 'ltr',
            textAlign: isRtl ? 'right' : 'left' 
        }} 
                value={value} 
                id={field.sourceField} 
                className={`${classes.field} ${showRequired ? classes.requiredField : ''}`} 
                placeholder={field.fieldName} 
                onChange={onChangeHandler}                
                name={field.fieldName} 
                type={field.type} 
                required={field.required}
                onKeyDown={(e) => {
                   if (e.keyCode === 69 || e.keyCode === 187){
                        e.preventDefault()
                    }}}                    
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />
        </>
    )
}